import React, { useState, useEffect  } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
//import ReCAPTCHA from 'react-google-recaptcha';

const validationSchema = Yup.object().shape({
  username: Yup.string().required("Le nom d'utilisateur est requis"),
  password: Yup.string().min(6, 'Le mot de passe doit avoir au moins 6 caractères').required('Le mot de passe est requis'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Les mots de passe doivent correspondre')
    .required('La confirmation du mot de passe est requise'),
  roles: Yup.string().oneOf(['SUPERADMIN', 'USER', 'ANONYM'], 'Rôle invalide').required('Le rôle est requis'),
});

function CreactUsers() {

  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onSubmit = (values, { resetForm }) => {
    const { username, password, roles, bataillonId } = values;
    axios
      .post('/auth', { username, password, roles, bataillonId })
      .then((response) => {
        toast.warn('Utilisateur créé avec succès:', response.data.message);
        navigate('/login');
      })
      .catch((error) => {
        setError(error.response?.data?.error || "Erreur d'enregistrement");
        console.error("Erreur lors de la création de l'utilisateur:", error);
      });
   };

  return (
    <div className="container mt-5 pt-5">
      <div className="col-md-6 mx-auto bg-warning p-5 rounded-lg">
        <div className="bg-primary p-3 rounded-lg">
          <h1>Nouvel utilisateur</h1>
        </div>
        <Formik
          initialValues={{
            username: '',
            password: '',
            confirmPassword: '',
            roles: 'USER',
            bataillonId: '', // 👈 nouveau champ
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group">
                <label htmlFor="username">Nom d'utilisateur</label>
                <Field type="text" id="username" name="username" className="form-control" placeholder="Entrez le nom d'utilisateur" />
                <ErrorMessage name="username" component="div" className="text-danger" />
              </div>

              <div className="form-group">
                <label htmlFor="password">Mot de passe</label>
                <Field type="password" id="password" name="password" className="form-control" placeholder="Entrez le mot de passe" />
                <ErrorMessage name="password" component="div" className="text-danger" />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmez le mot de passe</label>
                <Field type="password" id="confirmPassword" name="confirmPassword" className="form-control" placeholder="Confirmez le mot de passe" />
                <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
              </div>
              <div className="form-group">
                <label htmlFor="roles">Rôle</label>
                <Field as="select" id="roles" name="roles" className="form-control">
                  <option value="">Sélectionnez un rôle</option>
                  <option value="SUPERADMIN">SUPERADMIN</option>
                  <option value="USER">USER</option>
                  <option value="ANONYM">ANONYM</option>
                </Field>
                <ErrorMessage name="roles" component="div" className="text-danger" />
              </div>

{/*               <ReCAPTCHA sitekey="your-site-key" onChange={(value) => setCaptchaToken(value)} />
 */}
              <button type="submit">
                Créer l'utilisateur
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CreactUsers;
